/* eslint-disable no-useless-escape */
export type IEscapeJSON = (val: string) => string;

export function escapeJSON(val: string): string {
  try {
    return val
      .replace(/[\\]/g, '\\\\')
      .replace(/[\"]/g, '\\"')
      .replace(/[\/]/g, '\\/')
      .replace(/[\b]/g, '\\b')
      .replace(/[\f]/g, '\\f')
      .replace(/[\n]/g, '\\n')
      .replace(/[\r]/g, '\\r')
      .replace(/[\t]/g, '\\t');
  } catch (error) {
    console.error('JSON Escape Failed! ', error);
    return '';
  }
}
